module.exports = __webpack_public_path__ + "static/img/5.407845f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/5.jpg
// module id = TQsI
// module chunks = 1